import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { _BudgetRPFactory, _RemoteAbstractAction, _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import { BasicTable, MASK_MONEY } from "../../../../../../theme/Component/BasicTable";
import { ListMenu } from "../../../../../../theme/Component/ListMenu";
import { Modal } from "../../../../../../theme/Component/Modal";
import { InputMoney } from "../../../../../../theme/Input/InputMoney";
import { BasicButton } from "../../../../../../theme/Component/BasicButton";
import { PrintJson } from "../../../../../../theme/Component/PrintJson";
import { SelectProductEditor } from "../../../../../../Factoty&Production/ManufacturingStandars/Components/SelectProductEditor";
import { _CreateProductRowvDOS } from "../../../../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicSwitch } from "../../../../../../theme/Component/BasicSwitch";
import { ProductTaxsCatalogForAddedValue } from "../../../../../../Inventories-Warehouses/Product/ProductTaxes/ProductTaxsCatalogForAddedValue";
import { toast } from "react-toastify";
import { ProductValueTypeConstantsSelect } from "./ProductValueTypeConstantsSelect";
import { ModalConfirm } from "../../../../../../theme/Component/ModalConfirm";


interface Props {
    idApplicationInvoker: number,
    properties: any;
    data: any;
    setData: any;
    lastStep: boolean;
}
export const InventoryFactory = ({ idApplicationInvoker, properties, lastStep, data, setData }: Props) => {
    const { instance, update, handleChange, deleteItemVoid } = useDataBean(_CreateProductRowvDOS);
    const [bean, setBean] = useState<any>({});
    const [lista, setLista] = useState<any>([]);
    const [showFile, setShowFile] = useState<any>(null)
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    // const { lista, setLista, bean, setBean } = useDataBean(_RemoteAbstractAction);
    const [addtable, setAddtable] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [definir, setDefinir] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [prevBean, setPrevBean] = useState<any>(null);



    useEffect(() => {
        if(properties.ProductList)
        setLista(properties.ProductList);
    }, [properties])



    const head = [
        { title: 'ID', property: 'IDProduct', visible: true },
        { title: 'Producto', property: 'Description', visible: true },
        { title: 'Código Medida', property: 'MeasurementUnitCode', visible: true },
        { title: 'Unidad Medida', property: 'MeasurementUnitName', visible: true },
        { title: 'Valor Unitario', property: 'UnitaryValue', visible: true, MASK_MONEY },
        { title: 'Cantidad', property: 'Quantity', visible: true, MASK_MONEY },
        { title: 'Sub Total', property: 'Subtotal', visible: true, MASK_MONEY },
        { title: 'Impuestos', property: 'TaxAmount', visible: true, MASK_MONEY },
        { title: 'Valor Total', property: 'TotalValue', visible: true, MASK_MONEY },

    ]


    const headdos = [
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Base', property: 'BaseValue', visible: true },
        { title: '%', property: 'TaxTariff', visible: true },
        { title: 'Valor Impuesto', property: 'TaxValue', visible: true },


    ]

    const create = () => {
        setBean({
            IDEmployee: _single.getAccountID(),
            ProductValueType: 13
        });
        setModal({ ...modal, "view": true, "name": "Agregar" });
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const createProductRow = () => {


        instance.createProductRow(bean.IDProduct, properties.IDStore, bean.Quantity, bean.TotalValue, bean.AddedTaxIncluded, bean.ProductValueType).then(
            (rta: any) => {
                let x = [...lista];
                x.push({ DataBeanProperties: rta, DataBeanName: 'inventory.Product' })
                setLista(x)
                console.log(rta)
                setModal({ ...modal, "view": false, "name": "Agregar" });
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const listaBotones = () => {
        const botones = [
            { titulo: 'Ver Impuesto', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setAddtable({ ...addtable, "view": true }) } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true }); deleteItem(); } },
            { titulo: 'Eliminar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModalC({ ...modalC, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const submitForm = () => {

        let key: any = Object.keys(data);
        console.log({ [key[0]]: lista });
        // console.log(key[0].EditorObjectClassForName);


        if (setData) {
            setData({ [key[0]]: lista });
        }
    }
    const editaItem = () => {
        createProductRow();

    }

    const deleteItem = () => {
        let temp = [];
        lista.forEach(element => {
            console.log(element);
            console.log(bean);

            if (element.DataBeanProperties != bean) {
                temp.push(element)
            }
        });
        setLista(temp)
        setModalC({ ...modalC, "view": false });
    }


    return (
        <div className="row">
            <div className="col-md-12">
                <PrintJson json={properties} />
                {/* <label>{data.BudgetList.Name}</label> */}
            </div>
            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <>
                        <div className="row">
                            <div className="col-md-12">

                                <SelectProductEditor renderValue={bean.Description} label="Producto" value={bean.IDProduct} onChange={(e) => { setBean({ ...bean, "IDProduct": e.IDProduct }) }} />

                            </div>
                            <div className="col-md-12">

                                <ProductValueTypeConstantsSelect label="Tipo de Valor" idSelector={bean.ProductValueType} onChange={(e) => { setBean({ ...bean, "ProductValueType": e }) }} />

                            </div>
                            <div className="col-md-6">
                                <label>Cantidad</label>
                                <input type="number" name="Quantity" className="form-control" value={bean.Quantity} onChange={(e) => { setBean({ ...bean, "Quantity": parseFloat(e.target.value) }) }} />

                            </div>
                            <div className="col-md-6">
                                <label>Valor Total</label>
                                <input type="number" name="TotalValue" className="form-control" value={bean.TotalValue} onChange={(e) => { setBean({ ...bean, "TotalValue": parseFloat(e.target.value) }) }} />

                            </div>
                        </div>
                        <div className="col-md-6">
                            <BasicSwitch label="Aplicar Impuestos ?" estado={bean.AddedTaxIncluded} eventChange={(e) => { setBean({ ...bean, "AddedTaxIncluded": e }) }} />
                        </div>
                        <div className="col-md-12">
                            {bean.AddedTaxIncluded &&
                                <>
                                    <div className="col-md-12 mt-3">
                                        <BasicButton eventClick={() => { setDefinir({ ...definir, "view": true, "name": `Definir Impuestos de Valor Agregado` }) }} icon="ri-file-copy-2-line" children={"Definir Impuestos de Valor Agregado"} />
                                    </div>
                                </>
                            }

                        </div>
                        {/* <PrintJson json={bean} /> */}
                    </>
                </Modal>
                <Modal modal={definir} updateModal={setDefinir}>
                    <>
                        <div className="row">



                            <div className="col-md-12">
                                <ProductTaxsCatalogForAddedValue _idProduct={bean.IDProduct} />
                            </div>

                        </div>

                    </>
                </Modal>

                <Modal modal={addtable} updateModal={setAddtable}>
                    <>
                        <strong>Ver Impuesto</strong>
                        {/* <PrintJson json={lista} /> */}
                        <BasicTable head={headdos} body={bean.AddedTaxList} rowSet={setBean} />

                    </>
                </Modal>
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item {bean.IDProduct}</strong>
                </ModalConfirm>
            </div>
            <div className="col-md-12">
                {/* <PrintJson json={lista} /> */}
                <BasicTable head={head} body={lista} rowSet={setBean} iconButtons={iconButtonsItem} listButtons={listaBotones()} />

            </div>

            <div className="col-md-12">
                <BasicButton icon="ri-send-plane-2-line" clase="primary" eventClick={submitForm}>Enviar</BasicButton>
            </div>

            <div className="col-md-12">

            </div>
        </div>
    )
}